import { Component } from '@angular/core';

/**
 * Generated class for the MenuProfileComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'menu-profile',
  templateUrl: 'menu-profile.html',
})
export class MenuProfileComponent {
  text: string;

  constructor() {
    this.text = 'Hello World';
  }
}



// WEBPACK FOOTER //
// ./src/components/menu-profile/menu-profile.ts